// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2ef5c8{text-align:right;font-weight:500;font-size:1.25em;margin-bottom:.75em}._2ef5c8 small{font-size:.75em;margin-right:.25em}._12b201{font-size:.875em}", ""]);
// Exports
exports.locals = {
	"date": "_2ef5c8",
	"stats": "_12b201"
};
module.exports = exports;
